import { useApi } from "./useApi";
import { pdfService } from "../services/pdf";
import { triggerBlobDownload } from "../lib/pdf";
import { GuiaInternacaoPayload, OpmePayload, ResumoPayload } from "../types/pdf.types";
import { RecursoFinal } from "../types/resources.types";

export function useDownloadOpme() {
  const api = useApi<Blob>();

  const download = async (payload: OpmePayload, filename: string) => {
    const blob = await api.request(() =>
      pdfService.downloadOpme(api.apiFetchBlob, payload)
    );
    if (blob) triggerBlobDownload(blob, filename);
  };

  return { download, loading: api.loading };
}

export function useDownloadGuiaInternacao() {
  const api = useApi<Blob>();

  const download = async (payload: GuiaInternacaoPayload, filename: string) => {
    const blob = await api.request(() =>
      pdfService.downloadGuiaInternacao(api.apiFetchBlob, payload)
    );
    if (blob) triggerBlobDownload(blob, filename);
  };

  return { download, loading: api.loading };
}

export function useDownloadResumo() {
  const api = useApi<Blob>();

  const download = async (payload: ResumoPayload, filename: string) => {
    const blob = await api.request(() =>
      pdfService.downloadResumo(api.apiFetchBlob, payload)
    );
    if (blob) triggerBlobDownload(blob, filename);
  };

  return { download, loading: api.loading };
}

export function useDownloadRecurso() {
  const api = useApi<Blob>();

  const download = async (payload: RecursoFinal, filename: string) => {
    const blob = await api.request(() =>
      pdfService.downloadRecurso(api.apiFetchBlob, payload)
    );
    if (blob) triggerBlobDownload(blob, filename);
  };

  return { download, loading: api.loading };
}
